import { createFileRoute } from '@tanstack/react-router';
import LabelsPage from '@/pages/setup/labels/LabelsPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export interface LabelsSearch {
  id?: string;
}

export const Route = createFileRoute('/_authenticated/setup/labels')({
  beforeLoad: () => requireSetupPageAccess('/setup/labels'),
  validateSearch: (raw: Record<string, unknown>): LabelsSearch => ({
    id: (raw.id as string) ?? undefined,
  }),
  component: LabelsPage,
});
